<template>
    <div id="main">
        <loader v-if="isLoading" />
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />
        <div class="listing-header mb-3">
            <div class="title-breadcrumb">
                <span v-if="this.idEndereco != null">
                    <h1 class="title">
                        {{
                            $t(cantEdit ? "endereco" : "editar-endereco")
                        }}: {{ endereco.nome }}
                        <a
                            class="pl-1"
                            v-if="hide.hideInfo"
                            @click="infoIsHidden()"
                        >
                            <b-icon
                                v-if="!hide.infoIsHidden"
                                icon="eye-off-outline"
                                type="is-danger"
                            />
                            <b-icon
                                v-if="hide.infoIsHidden"
                                icon="eye-outline"
                                type="is-success"
                            />
                        </a>
                    </h1>
                </span>
                <span v-else>
                    <h1 class="title">
                        {{ $t("adicionar-endereco") }}
                        <a
                            class="pl-1"
                            v-if="hide.hideInfo"
                            @click="infoIsHidden()"
                        >
                            <b-icon
                                v-if="!hide.infoIsHidden"
                                icon="eye-off-outline"
                                type="is-danger"
                            />
                            <b-icon
                                v-if="hide.infoIsHidden"
                                icon="eye-outline"
                                type="is-success"
                            />
                        </a>
                    </h1>
                </span>
            </div>
            <div class="header-buttons">
                <button class="delete-btn" type="button" @click="cancelar()">
                    {{ $t("cancelar") }}
                </button>
                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                    v-if="!cantEdit"
                >
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>
        <br />

        <div class="form-columns-fit">
            <div class="columns is-flex-wrap">
                <!-- 
        Mudanças de campos dependendo da seleção de pessoa (0: físico ou 1: jurídico)
        pessoa=0 -> cpfcnpj: CPF, ierg: RG
        pessoa=1 -> cpfcnpj: CNPJ, ierg: Inscrição estadual (IE)
        
        Na edição, o campo tipo de pessoa deve ficar bloqueado para edição.
        -->
                <div class="column is-3">
                    <v-input 
                        :id="generateId(22)"
                        ref="idErpInput"
                        v-model="endereco.idenderecoerp"
                        placeholder="placeholder-preencha"
                        :maxlength="30"
                        title="codigo"
                        required
                        tooltipLabel="cod-ref"
                        :invalid="!endereco.idenderecoerp"
                        uppercase
                    />
                </div>

                <div class="column is-4">
                    <vss-select
                        :id="generateId(1)"
                        ref="pessoaSelect"
                        title="pessoa"
                        :searchable="false"
                        :options="pessoaSelect"
                        v-model="pessoaSelected"
                        class="no-clear"
                        :required="true"
                        :mlLabels="true"
                        tooltipLabel="informacao-endereco-tipocliente"
                        @onBlurFunction="sendIsChanged('tipo')"
                        tooltipSize="is-small"
                        tooltipPosition="is-right"
                        :disabled="isUpdate || cantEdit"
                    />
                </div>

                <div
                    class="column is-5"
                    :class="{ loading: isSearchingCNPJ }"
                    v-if="this.pessoaSelected.id == 1"
                >
                    <v-input
                        :id="generateId(2)"
                        :key="generateId(2)"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        ref="cnpjInput"
                        class="no-clear"
                        v-model="endereco.cnpjcpf"
                        :invalid="invalidCnpjCpf"
                        @onBlurFunction="validateCnpjInner()"
                        placeholder="placeholder-preencha"
                        :msg="invalidCnpjCpfMsg"
                        :icon="'magnify'"
                        @input-action="getInfoByCNPJ"
                        v-mask="['##.###.###/####-##']"
                        title="cnpj"
                        :required="true"
                        :tooltipLabel="'informacao-endereco-cnpj'"
                        tooltipSize="is-small"
                        tooltipPosition="is-right"
                        :searchable="false"
                        :disabled="cantEdit"
                    />
                </div>
                <div
                    class="column is-4"
                    v-else-if="this.pessoaSelected.id == 0"
                >
                    <v-input
                        :id="generateId(3)"
                        :key="generateId(3)"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        ref="cpfInput"
                        class="no-clear"
                        v-model="endereco.cnpjcpf"
                        :invalid="invalidCnpjCpf"
                        @onBlurFunction="validateCpfInner()"
                        placeholder="placeholder-preencha"
                        :msg="invalidCnpjCpfMsg"
                        v-mask="['###.###.###-##']"
                        title="cpf"
                        :required="true"
                        :tooltipLabel="'informacao-endereco-cpf'"
                        tooltipSize="is-small"
                        tooltipPosition="is-right"
                        :searchable="false"
                        :disabled="cantEdit"
                    />
                </div>
                <div class="column is-5">
                    <v-input
                        :id="generateId(4)"
                        ref="nomeInput"
                        title="nome"
                        placeholder="placeholder-preencha"
                        :msg="invalidNomeMsg"
                        v-model="endereco.nome"
                        :invalid="invalidNome"
                        :required="true"
                        :onBlurFunction="validateNome"
                        tooltipLabel="informacao-endereco-nome"
                        tooltipSize="is-small"
                        :disabled="cantEdit"
                        :maxlength="100"
                    />
                </div>
                <!-- 
        Mudanças de campos dependendo da seleção de pessoa (0: físico ou 1: jurídico)
        pessoa=0 | cpfcnpj: CPF, ierg: RG
        pessoa=1 | cpfcnpj: CNPJ, ierg: Inscrição estadual
        
        Na edição, o campo tipo de pessoa deve ficar bloqueado para edição.
        -->
                <div class="column"
                    :class="pessoaSelected.id == 1 ? 'is-3' : 'is-6'">
                    <vss-select
                        :id="generateId(5)"
                        ref="tipoEnderecoInput"
                        class="no-clear"
                        v-model="tipoEnderecoSelected"
                        title="informacao-tipo-endereco"
                        placeholder="selecione"
                        :required="true"
                        :invalid="invalidTipoEndereco"
                        :onBlurFunction="validateTipoEndereco"
                        :msg="invalidTipoEnderecoMsg"
                        :options="tipoEnderecoSelect"
                        :tooltipLabel="'informacao-endereco-tipoendereco'"
                        tooltipSize="is-small"
                        tooltipPosition="is-right"
                        :searchable="false"
                        :disabled="cantEdit"
                    />
                </div>
                <div class="column is-4" v-if="this.pessoaSelected.id == 1">
                    <v-input
                        :id="generateId(6)"
                        :key="generateId(6)"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        ref="iergInput"
                        class="no-clear"
                        v-model="endereco.ierg"
                        placeholder="placeholder-preencha"
                        :tooltipLabel="'informacao-endereco-ie'"
                        tooltipSize="is-small"
                        tooltipPosition="is-right"
                        title="ie"
                        :disabled="cantEdit"
                        :maxlength="20"
                    />
                </div>
                <div
                    class="column is-6"
                    v-else-if="this.pessoaSelected.id == 0"
                >
                    <v-input
                        :id="generateId(7)"
                        :key="generateId(7)"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        ref="iergInput"
                        class="no-clear"
                        v-model="endereco.ierg"
                        :tooltipLabel="'informacao-endereco-rg'"
                        tooltipSize="is-small"
                        tooltipPosition="is-right"
                        placeholder="placeholder-preencha"
                        title="rg"
                        :disabled="cantEdit"
                        :maxlength="20"
                    />
                </div>
                <div v-if="pessoaSelected.id == 1" class="column is-6">
                    <v-input
                        :id="generateId(8)"
                        ref="rsocialInput"
                        title="razaosocial"
                        placeholder="placeholder-preencha"
                        :msg="invalidRsocialMsg"
                        v-model="endereco.rsocial"
                        :invalid="invalidRsocial"
                        :required="true"
                        :onBlurFunction="validateRsocial"
                        tooltipLabel="informacao-endereco-rsocial"
                        tooltipSize="is-small"
                        :disabled="cantEdit"
                        :maxlength="100"
                    />
                </div>
                <div class="column is-6">
                    <vss-select
                        :id="generateId(20)"
                        ref="entregaPadraoInput"
                        title="entrega-padrao"
                        :searchable="false"
                        :options="opcoesPadraoSelect"
                        v-model="entregaPadraoSelected"
                        class="no-clear"
                        :required="true"
                        :mlLabels="true"
                        :disabled="cantEdit"
                        tooltipLabel="informacao-endereco-entrega-padrao"
                        tooltipSize="is-small"
                        tooltipPosition="is-right"
                    />
                </div>
                <div class="column is-7">
                    <vss-select
                        :id="generateId(21)"
                        ref="cobrancaPadraoInput"
                        title="cobranca-padrao"
                        :searchable="false"
                        :options="opcoesPadraoSelect"
                        v-model="cobrancaPadraoSelected"
                        class="no-clear"
                        :required="true"
                        :mlLabels="true"
                        tooltipLabel="informacao-endereco-cobranca-padrao"
                        tooltipSize="is-small"
                        tooltipPosition="is-right"
                        :disabled="cantEdit"
                    />
                </div>
                <div class="column is-5" :class="{ loading: isSearchingCEP }">
                    <v-input
                        :id="generateId(9)"
                        :key="generateId(9)"
                        ref="cep"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        v-model="endereco.cep"
                        title="cep-do-cliente"
                        placeholder="cep-do-cliente-placeholder"
                        v-mask="['##.###-###']"
                        @input-action="getInfoByCEP"
                        :tooltipLabel="'informacao-endereco-cep'"
                        :icon="'magnify'"
                        tooltipSize="is-small"
                        tooltipPosition="is-right"
                        :disabled="cantEdit"
                    />
                </div>
                <div class="column is-6">
                    <vss-select
                        :id="generateId(10)"
                        ref="cidadeInput"
                        title="cidade"
                        placeholder="selecione"
                        :msg="invalidCidadeMsg"
                        label="nome"
                        v-model="cidadeSelected"
                        :options="cidadeSelect"
                        :invalid="invalidCidade"
                        :required="true"
                        :onBlurFunction="validateCidade"
                        tooltipLabel="informacao-endereco-cidade"
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        searchable
                        @search="loadCidade"
                        :onChange="this.updateCidade()"
                        @onBlurFunction="sendIsChanged()"
                        :disabled="cantEdit"
                    />
                </div>
                <div class="column is-6">
                    <v-input
                        :id="generateId(11)"
                        ref="bairroInput"
                        title="bairro"
                        placeholder="placeholder-preencha"
                        v-model="endereco.bairro"
                        tooltipLabel="informacao-endereco-bairro"
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="cantEdit"
                        :maxlength="255"
                    />
                </div>
                <div class="column is-9">
                    <v-input
                        :id="generateId(12)"
                        ref="enderecoInput"
                        v-model="endereco.endereco"
                        placeholder="placeholder-preencha"
                        title="endereco"
                        :tooltipLabel="'informacao-endereco-endereco'"
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="cantEdit"
                        :maxlength="255"
                        :onBlurFunction="validateEndereco"
                        :msg="invalidEnderecoMsg"
                        :invalid="invalidEndereco"
                        required
                    />
                </div>
                <div class="column is-3">
                    <v-input
                        :id="generateId(13)"
                        ref="numeroInput"
                        v-model="endereco.numero"
                        placeholder="placeholder-preencha"
                        title="numero"
                        :msg="invalidNumeroMsg"
                        :invalid="invalidNumero"
                        :required="true"
                        :onBlurFunction="validateNumero"
                        :vMask="['##########']"
                        :tooltipLabel="'informacao-endereco-numero'"
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="cantEdit"
                    />
                </div>
                <div class="column is-12">
                    <v-input
                        :id="generateId(14)"
                        ref="complementoInput"
                        v-model="endereco.complemento"
                        placeholder="placeholder-preencha"
                        title="complemento"
                        :tooltipLabel="'informacao-cliente-complemento'"
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="cantEdit"
                        :maxlength="500"
                    />
                </div>
                <div class="column is-6">
                    <v-input
                        :id="generateId(15)"
                        ref="latitudeInput"
                        v-model="endereco.latitude"
                        placeholder="placeholder-preencha"
                        title="latitude"
                        :tooltipLabel="'informacao-endereco-latitude'"
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        validchars="0123456789-."
                        :disabled="cantEdit"
                        :maxlength="14"
                    />
                </div>
                <div class="column is-6">
                    <div class="field has-addons">
                        <div class="control is-expanded">
                            <v-input
                                :id="generateId(16)"
                                ref="longitudeInput"
                                v-model="endereco.longitude"
                                placeholder="placeholder-preencha"
                                title="longitude"
                                :tooltipLabel="'informacao-endereco-longitude'"
                                tooltipSize="is-small"
                                tooltipPosition="is-top"
                                validchars="0123456789-."
                                :disabled="cantEdit"
                                :maxlength="14"
                            />
                        </div>
                        <div
                            class="control padding-label padding-label-custom"
                            v-if="!cantEdit"
                        >
                            <b-button
                                @click="openLocationEditor"
                                icon-right="map-marker"
                                type="is-primary"
                                v-tippy 
                                :title="$t('pesquisar-localizacao')"
                            />
                        </div>
                    </div>
                </div>
                <div class="column is-6">
                    <v-input-tel
                        :id="generateId(17)"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        ref="telefoneInput"
                        title="telefone"
                        v-model="endereco.telefone"
                        :invalid="invalidTelefone"
                        :onBlurFunction="validateTelefone"
                        :msg="invalidTelefoneMsg"
                        tooltipLabel="informacao-endereco-telefone"
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :edit="inputTelefoneEdit"
                        :disabled="cantEdit"
                    />
                </div>
                <div class="column is-6">
                    <v-input-tel
                        :id="generateId(18)"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        ref="celularInput"
                        title="celular"
                        v-model="endereco.celular"
                        :invalid="invalidCelular"
                        :onBlurFunction="validateCelular"
                        :msg="invalidCelularMsg"
                        tooltipLabel="informacao-endereco-celular"
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        @input-action="copyWhatsApp"
                        :icon="'content-copy'"
                        :edit="inputCelularEdit"
                        :disabled="cantEdit"
                    />
                </div>
                <div class="column is-6">
                    <v-input-tel
                        v-if="!copyWhatsAppActive"
                        :id="generateId(19)"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        ref="faxInput"
                        title="fax-do-cliente"
                        v-model="endereco.fax"
                        :invalid="invalidFax"
                        :onBlurFunction="validateFax"
                        :msg="invalidFaxMsg"
                        tooltipLabel="informacao-endereco-fax"
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :edit="inputFaxEdit"
                        :disabled="cantEdit"
                    />
                </div>
            </div>
        </div>

        <MapasGoogleMapsModal
            v-if="startedMaps"
            :center="center"
            :isUpdating="isSaving"
            :locationEditorOpen="locationEditorOpen"
            :update="isUpdate"
            label="selecionar"
            @updateLocation="updateLocation"
            @onCancelLocationEditor="onCancelLocationEditor"
            :startSearchWith="startSearchWith"
        />
    </div>
</template>

<script>
import AssEnderecoCliente from "@/services/vendas/cliente/abas/AssClienteEnderecoService";
import CidadeService from "@/services/CidadeService";
import TipoEnderecoService from "@/services/vendas/TipoEnderecoService";
import EnderecoValidation from "@/services/validations/vendas/cliente/EnderecoValidation";
import MapasGoogleMapsModal from "@/components/shared/maps/MapasGoogleMapsModal";
import Message from "@/models/Message";
import HideInfo from "@/components/shared/HideInfo";
import { mapState } from "vuex";

export default {
    components: {
        HideInfo,
        CidadeService,
        MapasGoogleMapsModal,
        TipoEnderecoService,
    },
    props: {
        idCliente: {
            type: Number,
            default: null,
        },
        idEndereco: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            cleanHide: true,
            assClienteEnderecoIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes("ENDERECO"),
            service: new AssEnderecoCliente(this.$http, this.$router),
            cidadeService: new CidadeService(this.$http, this.$router),
            tipoEnderecoService: new TipoEnderecoService(
                this.$http,
                this.$router
            ),
            validation: new EnderecoValidation(this.msgs),
            isLoading: false,
            isSaving: false,
            msgs: [],
            endereco: {
                idendereco: null,
                idenderecoerp: null,
                idtipoendereco: null,
                idcliente: this.idCliente,
                idcidade: null,
                nome: null,
                rsocial: null,
                cnpjcpf: null,
                ierg: null,
                endereco: null,
                bairro: null,
                numero: null,
                complemento: null,
                telefone: null,
                fax: null,
                celular: null,
                latitude: null,
                longitude: null,
                cep: null,
                replicapda: null,
                cliente: {
                    idenderecocobrancapadrao: null,
                    idenderecoentregapadrao: null,
                },
                editEntregaPadrao: false,
                editCobrancaPadrao: false,
            },
            invalidTelefone: false,
            invalidCpf: false,
            invalidNome: false,
            invalidRsocial: false,
            invalidEndereco: false,
            invalidNumero: false,
            invalidCidade: false,
            invalidCnpjCpf: false,
            invalidCelular: false,
            invalidFax: false,
            invalidTipoEndereco: false,
            invalidNomeMsg: "msg-campo-obrigatorio",
            invalidRsocialMsg: "msg-campo-obrigatorio",
            invalidTelefoneMsg: "msg-campo-invalido",
            invalidCpfMsg: "msg-campo-invalido",
            invalidEnderecoMsg: "msg-campo-invalido",
            invalidNumeroMsg: "msg-campo-obrigatorio",
            invalidCidadeMsg: "msg-campo-obrigatorio",
            invalidCnpjCpfMsg: "msg-campo-invalido",
            invalidCelularMsg: "msg-campo-invalido",
            invalidFaxMsg: "msg-campo-invalido",
            invalidTipoEnderecoMsg: "msg-campo-obrigatorio",
            buscaCep: null,
            cidadeSelect: [],
            cidadeSelected: null,
            tipoEnderecoSelect: [],
            tipoEnderecoSelected: null,

            isSearchingCEP: false,
            isSearchingCNPJ: false,
            startedMaps: false,
            startSearchWith: "",
            locationEditorOpen: false,
            center: { lat: 0, lng: 0 },
            copyWhatsAppActive: false,
            entregaPadraoSelected: { label: "nao", id: 0 },
            cobrancaPadraoSelected: { label: "nao", id: 0 },

            pessoaSelect: [
                { label: "pessoa-juridica", id: 1 },
                { label: "pessoa-fisica", id: 0 },
            ],
            pessoaSelected: { label: "pessoa-juridica", id: 1 },

            opcoesPadraoSelect: [
                { label: "sim", id: 1 },
                { label: "nao", id: 0 },
            ],
            //para controlar algumas ações até os dados serem carregados na edição
            isLoadingEdit: false,
            startedData: false,
            isUpdate: this.idEndereco != null,
            cantEdit: false,
            permissao: false,

            inputFaxEdit: false,
            inputCelularEdit: false,
            inputTelefoneEdit: false,

            isVenda: this.$route.meta.contexto == "vendas",
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess(
            "vendas",
            "clientes",
            "ven-cliente-dados-cadastrais-endereco"
        );
        this.$emit("isChangedModal", false);
        if (this.idEndereco != null) {
            this.cantEdit =
                this.assClienteEnderecoIntegracao || !this.permissao.update;
            this.carregarDados(this.idEndereco);
        } else {
            this.loadTipoEndereco();
            this.startedMaps = true;
        }
    },
    computed: {
        ...mapState(["hide"]),
    },
    watch: {
        endereco: {
            deep: true,
            handler: function () {
                if (!this.isLoadingEdit) {
                    this.$emit("isChangedModal", true);
                }
            },
        },
    },
    methods: {
        // Emite ao componente pai se houve alteração em um campo select
        sendIsChanged(label = null) {
            if (!this.isLoadingEdit) this.$emit("isChangedModal", true);
            if (label == "tipo" && !this.isLoadingEdit) this.endereco.cnpjcpf = null;
        },
        infoIsHidden() {
            this.$store.dispatch("infoIsHidden", {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        fecharModal() {
            this.$emit("fecharModal", true);
        },
        carregarDados(id) {
            this.isLoading = true;
            this.isLoadingEdit = true;

            this.find(id)
                .then((value) => {
                    this.endereco = Object.assign(value.content);

                    if (this.endereco.replicapda == 2) this.cantEdit = true;

                    if (this.endereco.idcidade) {
                        this.loadCidadeById(this.endereco.idcidade);
                    }
                    // carrega info do select
                    this.loadTipoEndereco();

                    if (
                        this.endereco.cliente.idenderecocobrancapadrao ==
                        this.endereco.idendereco
                    ) {
                        this.endereco.editCobrancaPadrao = true;
                        this.cobrancaPadraoSelected = { label: "sim", id: 1 };
                    }
                    if (
                        this.endereco.cliente.idenderecoentregapadrao ==
                        this.endereco.idendereco
                    ) {
                        this.endereco.editEntregaPadrao = true;
                        this.entregaPadraoSelected = { label: "sim", id: 1 };
                    }

                    //Caso seja CPF, o tipo de pessoa selecionada deve ser alterado para pessoa fisica (pessoa juridica já é marcada como default)
                    if (this.endereco.cnpjcpf.length < 16) {
                        this.pessoaSelected = this.pessoaSelect[1];
                    }

                    this.checkEditTel();
                })
                .catch((e) => {
                    this.msgs.push(new Message("error", "msg-erro-load", true));
                })
                .finally(() => {
                    this.isLoading = false;
                    this.startedMaps = true;
                    this.$emit("isChangedModal", false);
                    this.isLoadingEdit = false;
                });
        },
        find(id) {
            if(this.isVenda) return this.service.findVendas(id);
            else return this.service.findAgro(id);
        }, 
        checkEditTel() {
            this.inputFaxEdit = !this.isNull(this.endereco.fax);
            this.inputCelularEdit = !this.isNull(
                this.endereco.telefone_celular
            );
            this.inputTelefoneEdit = !this.isNull(this.endereco.telefone);
        },
        runValidations(focusedOut = false) {
            if (focusedOut) {
                // Utilizado para ativar a validação dos campos ao carregar os dados de alteração
                Object.entries(this.$refs).forEach(([key, value]) => {
                    value.focusedOut = true;
                });
            }
            // Ao realizar o focusedOut no arquivo validation, as funções de validate não são chamadas, tendo assim que faze-las manualmente para poder apresentar os erros nos campos
            this.validateNome();
            this.validateTelefone();
            this.validateCelular();
            this.validateFax();
            this.pessoaSelect.id == 1
                ? this.validateCnpjInner()
                : this.validateCpfInner();
            this.validateRsocial();
            this.validateEndereco();
            this.validateNumero();
            this.validateCidade();
            this.validateTipoEndereco();
        },
        validateNome() {
            if (!this.isLoadingEdit) this.$emit("isChangedModal", true);
            if (this.isNull(this.endereco.nome)) {
                this.invalidNome = true;
                this.invalidNomeMsg = "msg-campo-obrigatorio";
            } else {
                this.invalidNome = false;
            }
        },
        validateRsocial() {
            if (!this.isLoadingEdit) this.$emit("isChangedModal", true);
            if (this.isNull(this.endereco.rsocial)) {
                this.invalidRsocial = true;
                this.invalidRsocialMsg = "msg-campo-obrigatorio";
            } else {
                this.invalidRsocial = false;
            }
        },
        validateTelefone() {
            if (!this.isLoadingEdit) this.$emit("isChangedModal", true);
            if (
                !this.isNull(this.endereco.telefone) &&
                !this.validatePhone(this.endereco.telefone)
            ) {
                this.invalidTelefone = true;
                this.invalidTelefoneMsg = "msg-campo-invalido";
            } else {
                this.invalidTelefone = false;
            }
        },
        validateCelular() {
            if (!this.isLoadingEdit) this.$emit("isChangedModal", true);
            if (
                !this.isNull(this.endereco.celular) &&
                !this.validatePhone(this.endereco.celular)
            ) {
                this.invalidCelular = true;
                this.invalidCelularMsg = "msg-campo-invalido";
            } else {
                this.invalidCelular = false;
            }
        },
        validateFax() {
            if (!this.isLoadingEdit) this.$emit("isChangedModal", true);
            if (
                !this.isNull(this.endereco.fax) &&
                !this.validatePhone(this.endereco.fax)
            ) {
                this.invalidFax = true;
                this.invalidFaxMsg = "msg-campo-invalido";
            } else {
                this.invalidFax = false;
            }
        },
        validateCnpjInner() {
            if (!this.isLoadingEdit) this.$emit("isChangedModal", true);
            if (this.isNull(this.endereco.cnpjcpf)) {
                this.invalidCnpjCpf = true;
                this.invalidCnpjCpfMsg = "msg-campo-obrigatorio";
            } else if (
                !this.isNull(this.endereco.cnpjcpf) &&
                !this.validateCnpj(this.endereco.cnpjcpf)
            ) {
                this.invalidCnpjCpf = true;
                this.invalidCnpjCpfMsg = "msg-campo-invalido";
            } else {
                this.invalidCnpjCpf = false;
            }
        },
        validateCpfInner() {
            if (!this.isLoadingEdit) this.$emit("isChangedModal", true);
            if (this.isNull(this.endereco.cnpjcpf)) {
                this.invalidCnpjCpf = true;
                this.invalidCnpjCpfMsg = "msg-campo-obrigatorio";
            } else if (
                !this.isNull(this.endereco.cnpjcpf) &&
                !this.validateCPF(this.endereco.cnpjcpf)
            ) {
                this.invalidCnpjCpf = true;
                this.invalidCnpjCpfMsg = "msg-campo-invalido";
            } else {
                this.invalidCnpjCpf = false;
            }
        },
        validateEndereco() {
            if (!this.isLoadingEdit) this.$emit("isChangedModal", true);
            if (this.isNull(this.endereco.endereco)) {
                this.invalidEndereco = true;
            } else {
                this.invalidEndereco = false;
            }
        },
        validateNumero() {
            if (!this.isLoadingEdit) this.$emit("isChangedModal", true);
            if (this.isNull(this.endereco.numero)) {
                this.invalidNumero = true;
                this.invalidNumeroMsg = "msg-campo-obrigatorio";
            } else {
                this.invalidNumero = false;
            }
        },
        validateCidade() {
            if (!this.isLoadingEdit) this.$emit("isChangedModal", true);
            if (this.isNull(this.cidadeSelected)) {
                this.invalidCidade = true;
                this.invalidCidadeMsg = "msg-campo-obrigatorio";
            } else {
                this.invalidCidade = false;
            }
        },
        validateTipoEndereco() {
            if (!this.isLoadingEdit) this.$emit("isChangedModal", true);
            if (this.isNull(this.tipoEnderecoSelected)) {
                this.invalidTipoEndereco = true;
                this.invalidTipoEnderecoMsg = "msg-campo-obrigatorio";
            } else {
                this.invalidTipoEndereco = false;
            }
        },

        generateId(numberId) {
            return this.$route.name + "-endereco-" + numberId;
        },
        //busca informações a partir do CNPJ
        getInfoByCNPJ() {
            new Promise((resolve, reject) => {
                if (this.cidadeSelected == null) {
                    this.$refs.cidadeInput.focusedOut = true;
                    reject("msg-erro-pesquisa-cnpj-cidade");
                    this.invalidCidade = true;
                    this.invalidCidadeMsg = "msg-preencha-data-pesquisa-cnpj";
                } else if (this.invalidCNPJ) {
                    reject("msg-erro-pesquisa-cnpj-invalido");
                }
                resolve();
            })
                .then((_) => {
                    this.isSearchingCNPJ = true;
                    this.service
                        .getInfoByCNPJ(
                            this.cidadeSelected.estado,
                            this.endereco.cnpjcpf
                        )
                        .then((res) => {
                            if (res.status != 200) {
                                if (res.status == 404) {
                                    console.error(`CNPJ ${cnpj} não existe.`);
                                    this.msgs.push(
                                        new Message(
                                            "error",
                                            "msg-erro-cnpj-inexistente",
                                            true
                                        )
                                    );
                                } else {
                                    console.error(`Retorno: ${res.status}`);
                                    this.msgs.push(
                                        new Message(
                                            "error",
                                            "msg-erro-pesquisa-cnpj",
                                            true
                                        )
                                    );
                                }
                            } else {
                                let r = JSON.parse(res.content);
                                let data = null;
                                if (typeof r == "object") {
                                    r.forEach((e) => {
                                        if (e.situacao == "1") data = e;
                                    });
                                } else if (r.length > 0) {
                                    data = r[r.length - 1];
                                }
                                if (data != null) {
                                    this.endereco.nome = data.nome;
                                    this.endereco.cep = data.cep;
                                    this.endereco.endereco = data.logradouro;
                                    this.endereco.numero = data.numero;
                                    this.endereco.bairro = data.bairro;
                                    this.endereco.ierg = data.ie;
                                    this.cidadeSelected =
                                        data.uf +
                                        " - " +
                                        data.descricaoMunicipio;
                                    this.loadCidade(
                                        data.descricaoMunicipio,
                                        data.uf
                                    );
                                }
                            }
                        })
                        .catch((e) => {
                            console.error(e);
                            this.msgs.push(
                                new Message(
                                    "error",
                                    "msg-erro-pesquisa-cnpj",
                                    true
                                )
                            );
                        })
                        .finally((_) => {
                            this.isSearchingCNPJ = false;
                        });
                })
                .catch((e) => {
                    this.msgs.push(new Message("error", e, true));
                });
        },
        //busca informações a partir do CEP
        getInfoByCEP() {
            if (this.endereco.cep == null) {
                this.msgs.push(
                    new Message("error", "msg-erro-pesquisa-cep-invalido", true)
                );
            } else {
                let cep = this.endereco.cep;
                this.isSearchingCEP = true;
                let token = this.$moment().format("!%$MM(yyyy)DD*&");
                token = this.$CryptoJS.MD5(token).toString();

                this.service
                    .getInfoByCEP(cep, token)
                    .then((data) => {
                        this.buscaCep = data.content;
                        this.endereco.bairro = data.content.bairro;
                        this.endereco.endereco = data.content.logradouro;
                        this.loadCidade(
                            this.removeAcentos(data.content.cidade)
                        );
                    })
                    .catch((err) => {
                        console.error(err);
                        this.msgs.push(
                            new Message("error", "msg-erro-pesquisa-cep", true)
                        );
                    })
                    .finally((_) => {
                        this.isSearchingCEP = false;
                    });
            }
        },
        //busca as opções de listagem, a partir do find all combo de tipo endereco
        loadTipoEndereco() {
            this.isLoadingEdit = true;
            this.tipoEnderecoService
                .findAllCombo("")
                .then((body) => {
                    return body.content.map((i) => {
                        return { id: i.id, label: i.descricao };
                    });
                })
                .then((tiposEndereco) => {
                    this.tipoEnderecoSelect = Object.assign(tiposEndereco);
                    this.tipoEnderecoSelect.sort();
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally((_) => {
                    this.$emit("isChangedModal", false);
                    this.isLoadingEdit = false;
                    if (
                        this.tipoEnderecoSelect.length > 0 &&
                        this.endereco.idtipoendereco != null &&
                        this.endereco.idtipoendereco != 0
                    ) {
                        this.tipoEnderecoSelected =
                            this.tipoEnderecoSelect.filter((f) => {
                                return f.id == this.endereco.idtipoendereco;
                            })[0];
                    }
                });
        },
        updateCidade() {
            if (this.cidadeSelected != null) {
                let cidadeTemp = this.cidadeSelect.filter(
                    (s) => s.id == this.cidadeSelected.id
                )[0];
                if (cidadeTemp != undefined) {
                    this.endereco.idcidade = cidadeTemp.id;
                }
            }
        },
        loadCidade(cidade, uf = null) {
            this.isLoadingEdit = true;
            if ((!cidade && this.cidadeSelected == null) || cidade) {
                this.cidadeService
                    .findAll(0, 100, cidade ? cidade : "")
                    .then((body) => {
                        return body.content.map((i) => {
                            return {
                                id: i.idcidade,
                                cidade: i.cidade,
                                nome: i.descricao,
                                estado: i.estado.descricao,
                            };
                        });
                    })
                    .then((allcidades) => {
                        this.cidadeSelect = Object.assign(allcidades);
                        this.cidadeSelect.sort();
                    })
                    .catch((e) => {
                        console.error(e);
                    })
                    .finally((_) => {
                        this.$emit("isChangedModal", false);
                        this.isLoadingEdit = false;
                        // foi colocado aqui para a busca com cep funcionar até com conexão fraca a internet
                        if (!this.isNull(this.buscaCep)) {
                            let idcidade = this.cidadeSelect.filter(
                                (s) => s.estado == this.buscaCep.uf
                            );
                            if (idcidade.length > 0) {
                                this.loadCidadeById(idcidade[0].id);
                            } else {
                                this.msgs.push(
                                    new Message(
                                        "alert",
                                        "cidade-nao-encontrada",
                                        true
                                    )
                                );
                            }
                            this.buscaCep = null;
                        } else if (uf != null) {
                            let idcidade = this.cidadeSelect.filter(
                                (s) => s.estado == uf
                            );
                            if (idcidade.length > 0) {
                                this.loadCidadeById(idcidade[0].id);
                            }
                        }
                    });
            }
        },
        loadCidadeById(id) {
            this.cidadeService
                .find(id)
                .then((cidade) => {
                    if (cidade.content != null) {
                        let temp = {
                            id: cidade.content.id,
                            nome: cidade.content.descricao,
                            cidade: cidade.content.cidade,
                            estado: cidade.content.estado.descricao,
                        };
                        this.cidadeSelected = temp;
                    } else {
                        console.warn("Busca de cidade vazia");
                    }
                }, 350)
                .catch((e) => {
                    console.error(e);
                });
        },
        //copia o valor de celular para fax
        copyWhatsApp() {
            this.copyWhatsAppActive = true;
            this.endereco.fax = this.endereco.celular;
            setTimeout(() => {
                this.copyWhatsAppActive = false;
            }, 100);
        },
        openLocationEditor() {
            if (this.isUpdate) {
                if (
                    !this.onlyNumbers(this.endereco.latitude) ||
                    !this.onlyNumbers(this.endereco.longitude)
                ) {
                    this.center.lat = 0;
                    this.center.lng = 0;
                } else {
                    this.center.lat = +this.endereco.latitude;
                    this.center.lng = +this.endereco.longitude;
                }
            }
            if (
                !this.isUpdate &&
                this.isNull(this.endereco.latitude) &&
                this.isNull(this.endereco.longitude)
            ) {
                if (!this.isNull(this.endereco.endereco))
                    this.startSearchWith = this.endereco.endereco;
                if (!this.isNull(this.endereco.numero))
                    this.startSearchWith =
                        this.startSearchWith + " " + this.endereco.numero;
                if (!this.isNull(this.endereco.bairro))
                    this.startSearchWith =
                        this.startSearchWith + " " + this.endereco.bairro;
                if (this.cidadeSelected != null) {
                    this.startSearchWith =
                        this.startSearchWith + " " + this.cidadeSelected.cidade;
                    this.startSearchWith =
                        this.startSearchWith + " " + this.cidadeSelected.estado;
                }
                setTimeout(() => {
                    this.$children[this.$children.length - 1].getLocation(this.startSearchWith);
    
                }, 1000)
            }
            this.locationEditorOpen = true;
        },
        onCancelLocationEditor() {
            this.locationEditorOpen = false;
            this.startSearchWith = "";
        },
        updateLocation(val) {
            this.center.lat = val.center.lat;
            this.center.lng = val.center.lng;
            this.endereco.latitude = this.center.lat;
            this.endereco.longitude = this.center.lng;
            this.onCancelLocationEditor();
        },
        cancelar() {
            this.$emit("promptChangeTab", true);
        },
        atualizarEnderecoCliente(enderecoTemp) {
            this.service.atualizaEnderecoPadrao(enderecoTemp).then((value) => {
                if (value.message == null) {
                    this.$emit("isChangedModal", false);
                    let msg = "msg-endereco-padrao-alterado";
                    this.msgs.push(new Message("success", msg, true));
                    this.$emit("isChanged", false);
                } else {
                    if (this.$t(value.message)) {
                        this.msgs.push(
                            new Message("alert", value.message, true)
                        );
                    } else {
                        this.msgs.push(
                            new Message(
                                "error",
                                "msg-problema-realizar-acao",
                                true
                            )
                        );
                    }
                }
            });
        },
        saveService(enderecoTemp) {
            this.isSaving = true;
            this.isLoadingEdit = true;
            this.saveEndereco(enderecoTemp)
                .then((value) => {
                    if (value.message == null) {
                        if (
                            (enderecoTemp.cliente.idenderecoentregapadrao !=
                                0 &&
                                !enderecoTemp.editEntregaPadrao) ||
                            (enderecoTemp.cliente.idenderecocobrancapadrao !=
                                0 &&
                                !enderecoTemp.editCobrancaPadrao) ||
                            (enderecoTemp.cliente.idenderecoentregapadrao ==
                                0 &&
                                enderecoTemp.editEntregaPadrao) ||
                            (enderecoTemp.cliente.idenderecocobrancapadrao ==
                                0 &&
                                enderecoTemp.editCobrancaPadrao)
                        ) {
                            if (enderecoTemp.idendereco == null) {
                                enderecoTemp.idendereco =
                                    value.content.idendereco;
                            }
                            this.atualizarEnderecoCliente(enderecoTemp);
                        }
                        this.$emit("isChangedModal", false);
                        let msg =
                            this.endereco.idendereco != null
                                ? "msg-edit-cliente-endereco"
                                : "msg-save-cliente-endereco";
                        this.msgs.push(new Message("success", msg, true));
                        this.$emit("isChanged", false);
                        setTimeout(() => {
                            this.$emit("fecharModal", true);
                        }, 2500);
                    } else {
                        if (this.$t(value.message)) {
                            this.msgs.push(
                                new Message("alert", value.message, true)
                            );
                        } else {
                            this.msgs.push(
                                new Message(
                                    "error",
                                    "msg-problema-realizar-acao",
                                    true
                                )
                            );
                        }
                    }
                })
                .catch((e) => {
                    if (e.body.status == 409) {
                        this.msgs.push(
                            new Message(
                                "alert",
                                "msg-existe-codigo-cliente",
                                true
                            )
                        );
                    } else {
                        console.error("Erro ao salvar: " + e);
                        this.msgs.push(
                            new Message("error", "msg-erro-salvar", true)
                        );
                    }
                })
                .finally(() => {
                    this.cleanHide = false;
                    this.isSaving = false;
                    this.isLoading = false;
                    this.$emit("isChangedModal", false);
                    this.isLoadingEdit = false;
                    this.endereco.editCobrancaPadrao = false;
                    this.endereco.editEntregaPadrao = false;
                });
        },
        saveEndereco(endereco) {
            if(this.isVenda) return this.service.saveVendas(endereco);
            else return this.service.saveAgro(endereco);
        },
        prompt(enderecoTemp) {
            this.$root.confirm({
                message: this.$t("msg-alterar-endereco-padrao"),
                onConfirm: () => this.saveService(enderecoTemp),
                onCancel: () => this.removePrompt(),
            });
        },
        removePrompt() {
            this.isLoading = false;
        },
        save() {
            this.endereco.idtipoendereco =
                this.tipoEnderecoSelected != null
                    ? this.tipoEnderecoSelected.id
                    : null;
            this.endereco.cliente.idenderecocobrancapadrao =
                this.cobrancaPadraoSelected != null
                    ? this.cobrancaPadraoSelected.id
                    : null;
            this.endereco.cliente.idenderecoentregapadrao =
                this.entregaPadraoSelected != null
                    ? this.entregaPadraoSelected.id
                    : null;

            if (
                this.validation.validate(
                    this.endereco,
                    this.pessoaSelected.id,
                    this.$refs
                )
            ) {
                if(this.pessoaSelected.id == 0){
                    this.endereco.rsocial = ''
                }
                let enderecoTemp = Object.assign({}, this.endereco);
                if (
                    (enderecoTemp.cliente.idenderecoentregapadrao != 0 &&
                        !enderecoTemp.editEntregaPadrao) ||
                    (enderecoTemp.cliente.idenderecocobrancapadrao != 0 &&
                        !enderecoTemp.editCobrancaPadrao) ||
                    (enderecoTemp.cliente.idenderecoentregapadrao == 0 &&
                        enderecoTemp.editEntregaPadrao) ||
                    (enderecoTemp.cliente.idenderecocobrancapadrao == 0 &&
                        enderecoTemp.editCobrancaPadrao)
                ) {
                    this.service
                        .verificaEnderecoPadrao(enderecoTemp)
                        .then((value) => {
                            if (!value.content) {
                                this.saveService(enderecoTemp);
                            } else {
                                this.prompt(enderecoTemp);
                            }
                        });
                } else {
                    this.saveService(enderecoTemp);
                }
            } else {
                this.runValidations();
                this.msgs.push(
                    new Message("alert", "msg-campos-invalidos", true)
                );
                this.isLoading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 30px 30px;
}
</style>